import { Route, Switch, useRouteMatch, Redirect, useLocation, useHistory } from "react-router-dom";
import ChatList from "./ChatList";
//import MessagesList from "./MessagesList";

const ChatPage = (props) => {
    let { path } = useRouteMatch();
    const { pathname } = useLocation();

	const history = useHistory();
	if (!window.reactHistory) {
        // attach history object to window object for use in push notification handler
        //https://stackoverflow.com/questions/71611267/access-react-router-dom-history-object-outside-react-component
        window.reactHistory = history; 
	}

    return <Switch>
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        {/*<Route path={`${path}/:id/conversations/:twilio_conversation_unique_name/interactivechat`}><ChatScreen {...props}/></Route>*/}
        <Route path={`${path}/:id/conversations/:twilio_conversation_unique_name/interactivechat`}><ChatList {...props}/></Route>
        <Route path={`${path}/:id/conversations`}><ChatList {...props}/></Route>
        <Route exact path={path}><ChatList {...props}/></Route>
    </Switch>;
}

export default ChatPage;
